// extracted by mini-css-extract-plugin
export default {"contents":"styles__contents___ybEAP"};